import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { cn } from '@/lib/utils'

import { Seo, Layout } from '@/components/generals'

interface Plan {
    listId: string
    itemId: string
    name: string
    price: string
    description: string
    featured: boolean
    features: string[]
    cta: { label: string; href: string }
}

interface Faq {
    question: string
    answer: string
}

const plans: Plan[] = [
    {
        listId: 'w-node-bb91ceaa-06d0-2ec1-a620-bfcd18bff0df-98f5df8d',
        itemId: 'w-node-_0006f261-face-d8e0-43a5-88aa60d5be8f-98f5df8d',
        name: 'پروفیل شیار ۶',
        price: 'از ۵۵۰٬۰۰۰',
        description: 'پروفیل سبک برای قاب، میز و سازه‌های سبک.',
        featured: false,
        features: ['۲۰×۲۰ شیار ۶: از ۵۵۰٬۰۰۰ تومان', '۲۰×۴۰ شیار ۶: از ۹۴۶٬۰۰۰ تومان', 'آنودایز نقره‌ای یا مشکی', 'برش رایگان به اندازهٔ دلخواه'],
        cta: { label: 'سفارش پروفیل', href: '/contact' }
    },
    {
        listId: 'w-node-_986159ab-d85b-4506-4c82-583c6f9332ef-98f5df8d',
        itemId: 'w-node-_986159ab-d85b-4506-4c82-583c6f9332f2-98f5df8d',
        name: 'پروفیل V-Slot',
        price: 'از ۸۲۵٬۰۰۰',
        description: 'شیار V برای حرکت چرخ‌های V، پایهٔ دستگاه‌های OpenBuilds.',
        featured: true,
        features: ['V-Slot ۲۰×۲۰: از ۸۲۵٬۰۰۰ تومان', 'V-Slot ۲۰×۴۰: از ۱٬۲۰۰٬۰۰۰ تومان', 'آنودایز نقره‌ای یا مشکی', 'سازگار با صفحه‌ها و چرخ‌های OpenBuilds', 'برش رایگان به اندازهٔ دلخواه'],
        cta: { label: 'سفارش پروفیل', href: '/contact' }
    },
    {
        listId: 'w-node-_2cb91dee-387e-ee81-fab7-0ec4c2c9e9cb-98f5df8d',
        itemId: 'w-node-_2cb91dee-387e-ee81-fab7-0ec4c2c9e9ce-98f5df8d',
        name: 'پروفیل شیار ۸ و ۱۰',
        price: 'از ۱٬۲۱۰٬۰۰۰',
        description: 'برای شاسی‌های سنگین‌تر، میز کار و سازه‌های صنعتی.',
        featured: false,
        features: ['۳۰×۳۰ شیار ۸: از ۱٬۲۱۰٬۰۰۰ تومان', '۳۰×۶۰ شیار ۸: از ۲٬۱۵۰٬۰۰۰ تومان', '۴۰×۴۰ سه طرف بسته، یک شیار ۱۰: از ۱٬۸۵۰٬۰۰۰ تومان', 'برش رایگان به اندازهٔ دلخواه'],
        cta: { label: 'استعلام و سفارش', href: '/contact' }
    }
]

const faqs: Faq[] = [
    {
        question: 'قیمت پروفیل بریده‌شده چطور حساب می‌شود؟',
        answer: 'قیمت‌ها برای هر متر اعلام می‌شود و هر قطعه بر اساس سانتی‌متر محاسبه می‌شود. کسر سانتی‌متر به بالا گرد می‌شود و برش رایگان است.'
    },
    {
        question: 'پروفیل‌ها در چه رنگ‌هایی موجود است؟',
        answer: 'بیشتر پروفیل‌ها در دو رنگ آنودایز نقره‌ای و مشکی عرضه می‌شوند. رنگ موجود هر مدل را پیش از سفارش از ما بپرسید.'
    },
    {
        question: 'با چه روش‌هایی ارسال می‌کنید؟',
        answer: 'با پست پیشتاز (هزینه بر اساس وزن)، یا با تیپاکس، باربری و پیک که هزینهٔ ارسال در مقصد پرداخت می‌شود. کیت دستگاه و سفارش‌هایی که پروفیل دارند با پست ارسال نمی‌شوند.'
    },
    {
        question: 'امکان تحویل حضوری دارید؟',
        answer: 'خیر. تحویل حضوری نداریم و همهٔ سفارش‌ها از انبار تهران ارسال می‌شوند.'
    },
    {
        question: 'سفارش چند روزه آماده می‌شود؟',
        answer: 'سفارش‌های عادی در ۱ تا ۲ روز کاری آماده می‌شوند. سفارش‌هایی که برش یا کار اضافه دارند معمولاً ۱ تا ۴ روز کاری زمان می‌برند.'
    },
    {
        question: 'پرداخت چطور انجام می‌شود؟',
        answer: 'از طریق درگاه پرداخت آنلاین، یا کارت‌به‌کارت و پایا با ارسال رسید در واتس‌اپ یا بله. پرداخت در محل برای مبلغ سفارش نداریم.'
    }
]

const logoIds = [
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcd8-98f5df8d',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcda-98f5df8d',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcdc-98f5df8d',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcde-98f5df8d',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce0-98f5df8d',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce2-98f5df8d',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce4-98f5df8d',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce6-98f5df8d'
]

const Pricing: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title='پروفیل و قیمت' description='قیمت پروفیل شیاردار مهندسی شیار ۶، V-Slot و شیار ۸ و ۱۰ برای هر متر، با برش رایگان به اندازهٔ دلخواه و ارسال از تهران.' />

            {/* Pricing hero */}
            <div className='section'>
                <div className='container no-paddings'>
                    <div className='pricing-hero'>
                        <div className='center-title'>
                            <div className='title-holder'>
                                <div className='animate-on-load-01'>
                                    <h1 className='white-title'>پروفیل شیاردار مهندسی</h1>
                                </div>
                                <div className='animate-on-load-02'>
                                    <div className='experience-paragraph-holder'>
                                        <p>قیمت‌ها برای هر متر است. هر قطعه بر اساس سانتی‌متر محاسبه می‌شود و برش به اندازهٔ دلخواه رایگان است.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='animate-on-load-03'>
                        <div className='pricing-category-holder'>
                            <div className='pricing-category-container'>
                                <div className='pricing-category-wrapper'>
                                    <div className='pricing-category'>
                                        <div className='w-inline-block'>
                                            <div className='pricing-button active'>
                                                <div>قیمت هر متر</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='animate-on-load-04'>
                        <div className='pricing-table-holder'>
                            <div className='pricing-table-container'>
                                {plans.map((plan) => (
                                    <div key={plan.itemId} id={plan.listId} className='w-dyn-list'>
                                        <div role='list' className='w-dyn-items'>
                                            <div role='listitem' className='w-dyn-item'>
                                                <div id={plan.itemId} className={cn('pricing-item', plan.featured && 'middle')}>
                                                    <div className='pricing-item-container'>
                                                        <div className='product-link w-inline-block'>
                                                            <div className='pricing-title'>{plan.name}</div>
                                                            <div className='price-holder'>
                                                                <div className='price'>{plan.price}</div>
                                                                <div className='pricing-indicator'>تومان / هر متر</div>
                                                            </div>
                                                            <p>{plan.description}</p>
                                                            <div className='pricing-divider' />
                                                        </div>
                                                        <div className='pricing-list-holder'>
                                                            <div className='black-list w-richtext'>
                                                                <ul role='list' style={{ listStyleType: 'none', paddingRight: 0, paddingLeft: 0, marginTop: 0, marginBottom: 0 }}>
                                                                    {plan.features.map((feature) => (
                                                                        <li key={feature}>{feature}</li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div className='pricing-button-holder'>
                                                            <Link href={plan.cta.href} className='button add-to-cart'>{plan.cta.label}</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className='logo-grid-holder'>
                        <div className='w-layout-grid logo-grid'>
                            {logoIds.map((id, index) => (
                                <div key={id} id={id} className='logo-small-container'><img src={`/images/Logo0${index + 1}.svg`} loading='lazy' alt='' className='logo-small' /></div>
                            ))}
                        </div>
                        <div className='fade-in-move-on-scroll'>
                            <p>ساخته‌شده بر پایهٔ طرح‌های متن‌باز OpenBuilds</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* FAQ */}
            <div id='faq' className='section'>
                <div className='container'>
                    <div className='center-title'>
                        <div className='title-holder'>
                            <div className='fade-in-move-on-scroll'>
                                <h2 className='title'>خرید، ارسال و پرداخت</h2>
                            </div>
                            <div className='fade-in-move-on-scroll'>
                                <div className='experience-paragraph-holder'>
                                    <p>پاسخ پرسش‌های پرتکرار دربارهٔ سفارش پروفیل و قطعات.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='faq-holder'>
                        <div className='faq-container'>
                            {faqs.map((faq) => (
                                <div key={faq.question} className='faq-block'>
                                    <div className='faq-heading'>
                                        <div className='faq-question-text'>{faq.question}</div>
                                        <div className='faq-icon-holder'><img src='/images/Plus-Icon.svg' loading='lazy' alt='' className='faq-icon' /></div>
                                    </div>
                                    <div className='faq-answer-holder'>
                                        <div className='faq-answer'>{faq.answer}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='open-roles-cta-holder'>
                        <div className='open-roles-cta-container'>
                            <div className='open-roles-cta'>
                                <div className='content-holder'>
                                    <h2 className='h3-title'>سؤال دیگری دارید؟</h2>
                                    <div className='paragraph-open-roles'>
                                        <p>پاسخ سؤالتان را پیدا نکردید؟ تماس بگیرید یا در واتس‌اپ پیام بدهید.</p>
                                    </div>
                                </div>
                                <Link href='/contact' className='button w-button'>تماس با ما</Link><img src='/images/Open-Roles-Illustaion.svg' loading='eager' alt='' className='open-roles-illustation' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Pricing
